import { passwordValidationCodes } from "../../app/config/constants";

var passwordChecker = {
  check: (password, userId, needCheckUserName) => {
    let validCounter = 0;
    let validateMessages = [];
    // 1. Password Length >= 8
    validateMessages.push({ code: passwordValidationCodes.minLength.code, isValid: passwordChecker.minLength(password), message: passwordValidationCodes.minLength.message });
    // 2. Mixture of alphabets and numbers
    validateMessages.push({ code: passwordValidationCodes.alphaNumericMix.code, isValid: passwordChecker.alphaNumeric(password), message: passwordValidationCodes.alphaNumericMix.message });
    // 3. Contain at least one special character
    validateMessages.push({ code: passwordValidationCodes.specialCharactor.code, isValid: passwordChecker.specialCharacter(password), message: passwordValidationCodes.specialCharactor.message });
    // 4. Cannot enter consecutive number\Charactors in a row 4 times
    validateMessages.push({ code: passwordValidationCodes.recursiveNumber.code, isValid: !passwordChecker.consecutiveNumber(password), message: passwordValidationCodes.recursiveNumber.message });
    // 5. Continuous same word multiple times not allowed
    validateMessages.push({ code: passwordValidationCodes.sameWord.code, isValid: !passwordChecker.sameWord(password), message: passwordValidationCodes.sameWord.message });
    // 6. Special word not allowed in password
    validateMessages.push({ code: passwordValidationCodes.specialWord.code, isValid: passwordChecker.specialWord(password), message: passwordValidationCodes.specialWord.message });
    // 7. Password cannot contain User Id
    needCheckUserName && validateMessages.push({ code: passwordValidationCodes.noUserId.code, isValid: passwordChecker.noUserId(password, userId), message: passwordValidationCodes.noUserId.message });

    return { validCount: validCounter, validateMessages: validateMessages };
  },
  minLength: (password) => {
    return password.length >= 8;
  },
  alphaNumeric: (password) => {
    let pattern = /^(?=.*[a-zA-Z])(?=.*[0-9])/i;
    return pattern.test(password);
  },
  specialCharacter: (password) => {
    let specialChars = ['~', '!', '@', '#', '$', '%', '&', '*', '-', '=', '_', '[', ']', '{', '\'', '}'];
    return specialChars.some(v => password.includes(v))
  },
  consecutiveNumber: (password) => {
    if (password.length >= 4) {
      let arrNumberPattern = ["0123", "1234", "2345", "3456", "4567", "5678", "6789", "0987", "9876", "8765", "7654", "6543", "5432", "4321", "3210"];
      let arrCharPattern = ["abcd", "bcde", "cdef", "defg", "efgh", "fghi", "ghij", "hijk", "ijkl", "jklm", "klmn", "lmno"
        , "mnop", "nopq", "opqr", "pqrs", "qrst", "rstu", "stuv", "tuvw", "uvwx", "vwxy", "wxyz"];

      for (var n = 0; n < arrNumberPattern.length; n++) {
        if (password.includes(arrNumberPattern[n])) return true;
      }
      for (var n = 0; n < arrCharPattern.length; n++) {
        if (password.includes(arrCharPattern[n])) return true;
      }
      return false;
    } else {
      return false;
    }
  },
  sameWord: (password) => {
    let result = false;
    if (password.length >= 1) {
      for (var n = 2; n < 5; n++) {
        result = passwordChecker.testPatternSameWord(password, n);
        if (result) return result;
        result = passwordChecker.testPatternSameWord(password.substring(1, password.length), n);
        if (result) return result;
        result = passwordChecker.testPatternSameWord(password.substring(2, password.length), n);
        if (result) return result;
        result = passwordChecker.testPatternSameWord(password.substring(3, password.length), n);
        if (result) return result;
      }
    } else {
      result = false;
    }
    return result;
  },
  testPatternSameWord: (string, charCount) => {
    if (string.length >= 4) {
      let pattern = /\b(\S+)(?:\s+\1\b)+/
      let splitter = new RegExp(".{1," + charCount + "}", "g");
      let pArr = string.match(splitter);
      let sPassword = pArr.join(' ')
      let result = false;
      result = pattern.test(sPassword);
      if (result) return result;

      return false;
    } else {
      return false;
    }
  },
  specialWord: (password) => {
    if (password.length > 0) {
      let specialWords = ['sds', 'samsung', 'manager', 'admin', 'mcs'];
      return !specialWords.some(v => password.includes(v))
    } else {
      return true;
    }
  },
  noUserId: (password, userId) => {
    if (password.length > 0) {
      return password.indexOf(userId) == -1;
    } else {
      return true;
    }
  },
}

export default passwordChecker;
